import {Language, LanguageIso3} from "../../@types/generics.tsx";

export const languageToIso3 = (language: string) => {
    switch (language) {
        case Language.LT:
            return LanguageIso3.LT;
        case Language.EN:
            return LanguageIso3.EN;
        default:
            return LanguageIso3.LT;
    }
}
